import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {StringFormatType} from "../../_typing/config/string-format-type";
import {NgClass} from "@angular/common";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
    selector: 'string-format-selector',
    imports: [
        NgClass,
        MatTooltip
    ],
    templateUrl: './string-format-selector.component.html',
    styleUrl: './string-format-selector.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class StringFormatSelectorComponent {
    @Input() selectedFormat: StringFormatType;
    @Input() disabled: boolean;
    @Output() formatSelected = new EventEmitter<StringFormatType>;

    onFormatSelected($event: StringFormatType): void {
        this.selectedFormat = $event;
        this.formatSelected.emit($event);
    }

    protected readonly StringFormatType = StringFormatType;
}
